import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/cba/bx_cba_detail.png'
import _imports_1 from '../../assets/cba/jb_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-697b616a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col pageCbaDetail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "detailTop"
}, null, -1))
const _hoisted_3 = { class: "bgRed" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "detailTitle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailType" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, "活动说明：")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "detailType"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "购票链接：", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detailType" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, "领取方式：")
], -1))
const _hoisted_13 = { class: "detailContent" }
const _hoisted_14 = { class: "fixBtn items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_nb" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btnFont_big" }, "点击报名"),
  /*#__PURE__*/_createElementVNode("div", { class: "btnFont_little" }, "抽奖送福利")
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "btn btn_hb"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_nb" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btnFont_big1" }, "报名尚未开始"),
  /*#__PURE__*/_createElementVNode("div", { class: "btnFont_little1" }, "请关注报名时间")
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "btn btn_hb"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_nb" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btnFont_big1" }, "已结束"),
  /*#__PURE__*/_createElementVNode("div", { class: "btnFont_little1" }, "请关注其他抽奖福利")
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 3,
  class: "btn btn_hb"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_nb" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btnFont_big" }, "您已报名"),
  /*#__PURE__*/_createElementVNode("div", { class: "btnFont_little1" }, "请关注开奖时间")
], -1))
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.detailDatas.projectName), 1),
        _hoisted_6,
        _createVNode(_component_van_field, {
          class: "detailContent",
          modelValue: _ctx.detailDatas.instruction,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.detailDatas.instruction) = $event)),
          readonly: "",
          rows: "1",
          autosize: "",
          type: "textarea"
        }, null, 8, ["modelValue"]),
        (_ctx.detailDatas.ticketingLinkImg!='')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
          : _createCommentVNode("", true),
        (_ctx.detailDatas.ticketingLinkImg!='')
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.detailDatas.ticketingLinkImg,
              class: "codema"
            }, null, 8, _hoisted_11))
          : _createCommentVNode("", true),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.detailDatas.receiveMethod), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.detailDatas.signUpStatus == 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.btnSignUpKill()))
          }, _hoisted_16))
        : (_ctx.detailDatas.signUpStatus == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
          : (_ctx.detailDatas.signUpStatus == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
    ])
  ]))
}